import { AuthorizationLevel } from '@/types/schema';
import { PathsOf } from '@/types/subform';

export enum WaterfallAccess {
  View = 'view',
  Presentation = 'presentation',
  Editor = 'editor',
}

export interface RoleFormData {
  name: string;
  slug: string;
  isDefault: boolean;
  generalProperties: {
    canActAsRelationshipOwner: boolean;
    hasAllHouseholdsAccess: boolean;
    canModifyGlobalCategories: boolean;
    canModifyPrompts: boolean;
    canAccessTenantReporting: boolean;
    canApproveLuminarySupportTeamAccess: boolean;
    canApproveClientPresentations: boolean;
  };
  branding: AuthorizationLevel;
  employees: AuthorizationLevel;
  collaborators: AuthorizationLevel;
  households: AuthorizationLevel;
  waterfall: WaterfallAccess;
  dispositiveProvisions: AuthorizationLevel.View | AuthorizationLevel.Editor;
  auditLogs: AuthorizationLevel;
  roles: AuthorizationLevel;
  presentationTemplates: AuthorizationLevel;
}

export type RoleFormDataPaths = PathsOf<RoleFormData>;
